import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'
let serverUrl = getSecret('SERVER_URL');

export const getters = {
  getSourceFields() {
    return {model: 'plans_source', 
            label: 'Sources',
            fields: [
              { key: 'name', label: 'Name', type: 'text', sortable: true, required: true },
              { key: 'description', label: 'Description', type: 'text', sortable: true, required: false }
            ]}
  },
}

export const actions = {
  async fetchSources(context, query = '') {
    return axios
      .get(`${serverUrl}/api/masters/sources/${query}`)
      .then((response) => {
        return response.data;
      })
  },

  async createSources(context, { payload }) {
    return axios
      .post(`${serverUrl}/api/masters/sources/`, payload)
      .then((response) => {
        return response.data;
      })
  },

  async updateSources(context, { payload }) {
    return axios
      .patch(`${serverUrl}/api/masters/sources/${payload.id}/`, payload)
      .then((response) => {
        return response.data;
      })
  },

  async deleteSources(context, { id }) {
    return axios
      .delete(`${serverUrl}/api/masters/sources/${id}/`)
      .then((response) => {
        return response.data;
      })
  }
}